/* eslint-disable import/order */
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import styles from "../../styles/modal/modal.module.scss";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import useNotiStack from "../../hooks/useNotistack";
import dayjs from "dayjs";
import { IconButton } from "@mui/material";

export default function DatePickerModal({
  open,
  onClose,
  scroll,
  subscriptionDate,
  dateOfExpiration,
  isLoadingProductUpdate
}) {
  const { toastWarning } = useNotiStack();
  const [selectedDate, setSelectedDate] = useState();

  useEffect(() => {
    if (!open) {
      setSelectedDate(null);
    }
  }, [open]);

  const handleDateChange = (date) => {
    // e.stopPropagation();
    setSelectedDate(date);
  };

  const handleSaveDate = ()=>{
    if(selectedDate){
        subscriptionDate(selectedDate)
    }else{
        toastWarning("Please select another date.")
    }
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll={scroll}
      className={styles.date_cmn_modal}
      aria-labelledby="responsive-dialog-title"
    >
       <Box className={styles.datePickerheader}>
        <Typography variant="h6" className={styles.headerTitle}>
          Select Date
        </Typography>
        <IconButton onClick={onClose} className={styles.closeButton}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box className={styles.datepicker_section}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer
        components={["DateTimePicker", "DateTimePicker", "DateTimePicker"]}
      >
        <DemoItem>
          {/* <DateTimePicker
            views={["year", "month", "day", "hours", "minutes", "seconds"]}
            ampm={false} 
            value={selectedDate}
            onChange={handleDateChange}
          /> */}
           <DateTimePicker 
             views={["year", "month", "day"]}
             ampm={false}
             defaultValue={dayjs(dateOfExpiration)}
             onChange={handleDateChange}
        />
        </DemoItem>
      </DemoContainer>
    </LocalizationProvider>
    <button type="submit" className={styles.savebtn} onClick={handleSaveDate} >
    <Typography variant="caption" >{isLoadingProductUpdate ? "Saving.." : "Save"}</Typography>
    </button>
      </Box>
    </Dialog>
  );
}
